import { useState } from 'react';

interface Review {
  name: string;
  location: string;
  avatar: string;
  rating: number;
  date: string;
  title: string;
  body: string;
  tag: string;
  verified: boolean;
}

const reviews: Review[] = [
  {
    name: 'Abena Mensah',
    location: 'Accra, Ghana',
    avatar: 'https://public.readdy.ai/ai/img_res/3a05b758f0b5bf812f67180c411f22ca.jpg',
    rating: 5,
    date: 'February 2025',
    title: 'My energy levels have completely changed',
    body: 'I\'ve been taking 2 teaspoons every morning in warm water with honey for 6 weeks now. The difference in my energy — especially mid-afternoon when I used to crash — is remarkable. I also feel less bloated. I buy a 250g bag every month and I won\'t stop.',
    tag: 'Energy & Wellness',
    verified: true,
  },
  {
    name: 'Kwame Asante',
    location: 'Kumasi, Ghana',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20smiling%20Ghanaian%20man%20in%20his%2040s%2C%20clean-shaven%2C%20warm%20confident%20expression%2C%20neutral%20light%20background%2C%20soft%20natural%20lighting%2C%20portrait%20photography&width=80&height=80&seq=avatar-kwame&orientation=squarish',
    rating: 5,
    date: 'January 2025',
    title: 'My doctor actually noticed the difference',
    body: 'I started taking moringa because my iron levels were always low. After 2 months of daily use, my follow-up blood test showed significantly improved haemoglobin. My doctor asked what I changed — I told him moringa powder. He was genuinely impressed. The quality from MY AVA Farms is clearly the real thing.',
    tag: 'Iron & Blood Health',
    verified: true,
  },
  {
    name: 'Efua Darko',
    location: 'Takoradi, Ghana',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20smiling%20Ghanaian%20woman%20in%20her%20late%2020s%2C%20natural%20hair%2C%20bright%20warm%20eyes%2C%20clean%20light%20background%2C%20soft%20portrait%20lighting%2C%20genuine%20friendly%20expression&width=80&height=80&seq=avatar-efua&orientation=squarish',
    rating: 5,
    date: 'March 2025',
    title: 'I give this to my whole family — including my toddler',
    body: 'I was worried about giving supplements to my 3-year-old, but the team at MY AVA Farms walked me through safe dosage for children. I now mix a tiny amount into my daughter\'s porridge daily. She\'s thriving. My husband and I take the full serving. The powder dissolves easily, tastes mild, and the packaging is always airtight and fresh.',
    tag: 'Family & Children',
    verified: true,
  },
  {
    name: 'Nana Yaw Boateng',
    location: 'Accra, Ghana',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20Ghanaian%20man%20in%20his%20late%2020s%2C%20casual%20but%20polished%20style%2C%20warm%20smile%2C%20clean%20neutral%20background%2C%20natural%20daylight%20portrait%20photography&width=80&height=80&seq=avatar-nana&orientation=squarish',
    rating: 5,
    date: 'February 2025',
    title: 'Best moringa I\'ve tried — and I\'ve tried many',
    body: 'I\'ve ordered moringa from four different suppliers over the past two years. MY AVA Farms is the only one where the colour is consistently that deep, rich green — which tells you the leaves were processed at low heat and the nutrients are actually intact. Others sell a brownish powder and call it moringa. Not here. This is legit.',
    tag: 'Quality',
    verified: true,
  },
  {
    name: 'Maame Esi Amponsah',
    location: 'Cape Coast, Ghana',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20Ghanaian%20woman%20in%20her%2050s%2C%20mature%20graceful%20appearance%2C%20warm%20smile%2C%20clean%20background%2C%20soft%20natural%20lighting%2C%20genuine%20and%20confident%20expression%2C%20portrait%20photography&width=80&height=80&seq=avatar-maame&orientation=squarish',
    rating: 5,
    date: 'March 2025',
    title: 'Managing my blood sugar feels more under control',
    body: 'I\'m diabetic and was cautious about trying anything new. My nutritionist suggested moringa as a food supplement — not medication. I\'ve been adding it to my diet for 10 weeks and my fasting glucose readings have been more stable than they\'ve been in years. I also feel more alert and my skin looks healthier. Will keep ordering.',
    tag: 'Blood Sugar Support',
    verified: true,
  },
  {
    name: 'Kofi Twumasi',
    location: 'Tema, Ghana',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20Ghanaian%20man%20in%20his%2030s%2C%20athletic%20build%2C%20clean%20well-groomed%20appearance%2C%20confident%20smile%2C%20neutral%20light%20background%2C%20modern%20portrait%20photography&width=80&height=80&seq=avatar-kofi&orientation=squarish',
    rating: 5,
    date: 'January 2025',
    title: 'I add it to my post-workout smoothie every day',
    body: 'I\'m into fitness and was looking for a clean, natural protein and micronutrient source to complement my training. Moringa powder from MY AVA Farms fits perfectly. It blends seamlessly into my mango-banana smoothie, adds a nice earthy depth, and the recovery difference is real. Plus it\'s locally grown — I love supporting Ghanaian agriculture.',
    tag: 'Fitness & Recovery',
    verified: true,
  },
];

const tags = ['All', 'Energy & Wellness', 'Iron & Blood Health', 'Family & Children', 'Quality', 'Blood Sugar Support', 'Fitness & Recovery'];

function StarRating({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: 5 }).map((_, i) => (
        <span key={i} className="w-4 h-4 flex items-center justify-center">
          <i className={`ri-star-fill text-sm ${i < count ? 'text-amber-400' : 'text-gray-200'}`}></i>
        </span>
      ))}
    </div>
  );
}

export default function MoringaTestimonials() {
  const [activeTag, setActiveTag] = useState('All');
  const [expanded, setExpanded] = useState<number | null>(null);

  const filtered = activeTag === 'All' ? reviews : reviews.filter(r => r.tag === activeTag);

  const avgRating = (reviews.reduce((s, r) => s + r.rating, 0) / reviews.length).toFixed(1);

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12">
          <div>
            <span className="inline-block bg-amber-100 text-amber-700 text-sm font-semibold px-4 py-1.5 rounded-full mb-4 tracking-wide uppercase">
              Customer Reviews
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3">
              Real People. Real Results.
            </h2>
            <p className="text-gray-500 text-lg max-w-xl">
              Verified buyers across Ghana share how pure moringa powder has made a difference in their daily lives.
            </p>
          </div>

          {/* Aggregate rating */}
          <div className="flex items-center gap-5 bg-white border border-gray-200 rounded-2xl px-7 py-5 flex-shrink-0">
            <div className="text-center">
              <div className="text-5xl font-bold text-gray-900 leading-none">{avgRating}</div>
              <div className="mt-1.5">
                <StarRating count={5} />
              </div>
              <div className="text-xs text-gray-400 mt-1">{reviews.length} verified reviews</div>
            </div>
            <div className="h-16 w-px bg-gray-200"></div>
            <div className="space-y-1.5">
              {[5, 4, 3].map(star => {
                const count = reviews.filter(r => r.rating === star).length;
                const pct = Math.round((count / reviews.length) * 100);
                return (
                  <div key={star} className="flex items-center gap-2">
                    <span className="text-xs text-gray-500 w-3">{star}</span>
                    <span className="w-3 h-3 flex items-center justify-center">
                      <i className="ri-star-fill text-amber-400 text-xs"></i>
                    </span>
                    <div className="w-24 h-1.5 bg-gray-100 rounded-full overflow-hidden">
                      <div className="h-full bg-amber-400 rounded-full" style={{ width: `${pct}%` }}></div>
                    </div>
                    <span className="text-xs text-gray-400">{pct}%</span>
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        {/* Tag filter */}
        <div className="flex flex-wrap gap-2 mb-10">
          {tags.map(tag => (
            <button
              key={tag}
              onClick={() => setActiveTag(tag)}
              className={`px-4 py-2 rounded-full text-sm font-semibold transition-all cursor-pointer whitespace-nowrap ${
                activeTag === tag
                  ? 'bg-green-600 text-white'
                  : 'bg-white border border-gray-200 text-gray-600 hover:border-green-300 hover:text-green-700'
              }`}
            >
              {tag}
            </button>
          ))}
        </div>

        {/* Review cards grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {filtered.map((review, idx) => {
            const isExpanded = expanded === idx;
            const isLong = review.body.length > 180;
            return (
              <div
                key={idx}
                className="bg-white rounded-xl border border-gray-200 p-6 flex flex-col"
              >
                {/* Top row */}
                <div className="flex items-start justify-between gap-3 mb-4">
                  <div className="flex items-center gap-3">
                    <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0 bg-gray-100">
                      <img
                        src={review.avatar}
                        alt={review.name}
                        className="w-full h-full object-cover object-top"
                      />
                    </div>
                    <div>
                      <div className="font-semibold text-gray-900 text-sm">{review.name}</div>
                      <div className="text-xs text-gray-400 flex items-center gap-1">
                        <span className="w-3 h-3 flex items-center justify-center">
                          <i className="ri-map-pin-line text-xs"></i>
                        </span>
                        {review.location}
                      </div>
                    </div>
                  </div>
                  {review.verified && (
                    <span className="flex items-center gap-1 text-xs font-medium text-green-700 bg-green-50 border border-green-200 px-2.5 py-1 rounded-full flex-shrink-0">
                      <span className="w-3 h-3 flex items-center justify-center">
                        <i className="ri-shield-check-fill text-xs"></i>
                      </span>
                      Verified
                    </span>
                  )}
                </div>

                {/* Stars + date */}
                <div className="flex items-center gap-3 mb-3">
                  <StarRating count={review.rating} />
                  <span className="text-xs text-gray-400">{review.date}</span>
                </div>

                {/* Tag pill */}
                <span className="inline-block self-start bg-amber-50 text-amber-700 text-xs font-semibold px-3 py-1 rounded-full mb-3">
                  {review.tag}
                </span>

                {/* Review title */}
                <h4 className="font-bold text-gray-900 text-sm mb-2">{review.title}</h4>

                {/* Body */}
                <p className="text-gray-600 text-sm leading-relaxed flex-1">
                  {isLong && !isExpanded
                    ? `${review.body.slice(0, 180)}…`
                    : review.body}
                </p>

                {isLong && (
                  <button
                    onClick={() => setExpanded(isExpanded ? null : idx)}
                    className="mt-2 text-xs font-semibold text-green-600 hover:text-green-700 text-left cursor-pointer"
                  >
                    {isExpanded ? 'Show less' : 'Read more'}
                  </button>
                )}
              </div>
            );
          })}
        </div>

        {/* Bottom trust strip */}
        <div className="mt-14 grid grid-cols-2 md:grid-cols-4 gap-4">
          {[
            { icon: 'ri-shield-check-line', label: '100% Pure', sub: 'No additives or fillers' },
            { icon: 'ri-leaf-line', label: 'Grown in Ghana', sub: 'Locally farmed & processed' },
            { icon: 'ri-heart-pulse-line', label: 'Safe for All Ages', sub: 'Including children' },
            { icon: 'ri-truck-line', label: 'Nationwide Delivery', sub: 'Delivered across Ghana' },
          ].map((item, i) => (
            <div key={i} className="bg-white border border-gray-200 rounded-xl p-5 flex flex-col items-center text-center">
              <span className="w-10 h-10 flex items-center justify-center rounded-full bg-green-100 mb-3">
                <i className={`${item.icon} text-green-600 text-xl`}></i>
              </span>
              <div className="font-bold text-gray-900 text-sm">{item.label}</div>
              <div className="text-xs text-gray-400 mt-1">{item.sub}</div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="mt-10 text-center">
          <a
            href="https://paystack.shop/pay/v9-4hu3n50"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center bg-green-600 hover:bg-green-700 text-white font-semibold px-10 py-4 rounded-lg transition-colors cursor-pointer whitespace-nowrap text-base"
          >
            <i className="ri-shopping-bag-line mr-2 text-lg"></i>
            Order Pure Moringa Powder
          </a>
          <p className="text-xs text-gray-400 mt-3">Secure checkout via Paystack &middot; Available in 50g, 100g, 250g & 1kg</p>
        </div>

      </div>
    </section>
  );
}
